import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";
import { useTranslation } from "react-i18next";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function PrivacyPolicy(props) {
  const classes = useStyles();
  const { t } = useTranslation(["language"]);
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <br />
          <h2 className={classes.title}>{t("Use_information")}</h2>
          <p className={classes.description}>{t("Use_info_1")}</p>
          <p className={classes.description}>{t("Use_info_2")}</p>
          <p className={classes.description}>{t("Use_info_3")}</p>
          <p className={classes.description}>{t("Use_info_4")}</p>
          <p className={classes.description}>{t("Use_info_5")}</p>
          <p className={classes.description}>{t("Use_info_6")}</p>
          <p className={classes.description}>{t("Use_info_7")}</p>
          <p className={classes.description}>{t("Use_info_8")}</p>
          <br />
        </div>
      </div>

      <Footer />
    </div>
  );
}
